export class OrganizationCourseSearchItemModel {
	course_id: number;
	title: string;
	course_number: string;
}
